import React from "react";
import { Router as BrowserRouter } from "react-router-dom";
import { PagesSwitch } from "src/navigation/Switch";
import { history } from "src/navigation/store";
import { useHistory } from "src/navigation/useHistory";
import Modal from "src/components/organisms/Modals/index";
import { useAppSelector } from "src/store/hooks";
import { normalizeRole, UserRole } from "src/constants/roles";

export const Router: React.FC = () => {
  const { location, action } = useHistory();
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  let userRole: UserRole | null = null;

  if (isAuthenticated && user?.type) {
    userRole = normalizeRole(user.type);
  }

  return (
    <BrowserRouter
      location={location}
      navigationType={action}
      navigator={history}
    >
      <PagesSwitch userRole={userRole} />
      <Modal />
    </BrowserRouter>
  );
};
